import { computed, type Ref } from 'vue';
import { useQuery, type UseQueryReturnType } from '@tanstack/vue-query';
import type { AvailableModes } from '@/types/deepsign/AvailableModes';
import { useApi } from '@/composables/useApi.ts';

interface UseOrganizationAvailableModesParams {
  companyId: Ref<string | null | undefined>;
  enabled: Ref<boolean>;
}

export function useOrganizationAvailableModesQuery(
  params: UseOrganizationAvailableModesParams
): UseQueryReturnType<AvailableModes, Error> {
  const { deepSignAPI } = useApi();
  const queryKey = computed(() => ['organization', 'availableModes'] as const);

  const query = useQuery<AvailableModes, Error>({
    queryKey,
    enabled: params.enabled,
    queryFn: async () => {
      const response = await deepSignAPI.value.availableModes.get();
      const data = response?.data as AvailableModes | undefined;
      if (!data) throw new Error('No available modes data');
      return data;
    },
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });

  return query;
}
